const PART = { warm_up: 'Warm-up', pre_set: 'Pre-set', drill_set: 'Drill', main_set: 'Main', cool_down: 'Cool-down' };
const STYLE = { freestyle: 'free', backStroke: 'back', breastStroke: 'breast', butterfly: 'fly', individualMedley: 'IM' };
export const ZONE_LABEL = { rec: 'Rec', end1: 'End1', end2: 'End2', end3: 'End3', sp1: 'SP1', sp2: 'SP2', sp3: 'SP3' };
export const ZONE_ORDER = ['rec', 'end1', 'end2', 'end3', 'sp1', 'sp2', 'sp3'];

const part = item => `${item.reps || 1}×${item.distance || 0} ${STYLE[item.swimmingStyle] || ''}`.trim();
const subDistance = sub => (sub.reps || 1) * (sub.distance || 0);

// Distance of one item over all its sets, including sub-items.
const itemDistance = item =>
    ((item.reps || 1) * (item.distance || 0) + (item.subItems || []).reduce((a, s) => a + subDistance(s), 0)) *
    (item.set || 1);

/** Snapshot items (R5 DTO) -> table rows for the Sets table. Display only. */
export const toSetRows = items =>
    [...(items || [])]
        .sort((a, b) => (a.order || 0) - (b.order || 0))
        .map(item => {
            const subs = item.subItems || [];
            let description = [part(item), ...subs.map(part)].join(' + ');
            if ((item.set || 1) > 1) description = `${item.set} × (${description})`;
            const row = {
                part: PART[item.setType] || '',
                description,
                distance: itemDistance(item),
                zone: ZONE_LABEL[item.zones] || ''
            };
            if (item.comment) row.comment = item.comment;
            return row;
        });

/** Distance per zone as whole percentages that sum to 100 (largest remainder). */
export const zoneMix = items => {
    const totals = {};
    (items || []).forEach(item => {
        const sets = item.set || 1;
        totals[item.zones] = (totals[item.zones] || 0) + (item.reps || 1) * (item.distance || 0) * sets;
        (item.subItems || []).forEach(sub => {
            totals[sub.zones] = (totals[sub.zones] || 0) + subDistance(sub) * sets;
        });
    });
    const zones = ZONE_ORDER.filter(z => totals[z] > 0).map(z => ({ zone: z, label: ZONE_LABEL[z], distance: totals[z] }));
    const total = zones.reduce((a, z) => a + z.distance, 0);
    if (!total) return [];

    zones.forEach(z => {
        const exact = (z.distance / total) * 100;
        z.percent = Math.floor(exact);
        z.rem = exact - z.percent;
    });
    let left = 100 - zones.reduce((a, z) => a + z.percent, 0);
    [...zones].sort((a, b) => b.rem - a.rem).forEach(z => {
        if (left > 0) {
            z.percent += 1;
            left -= 1;
        }
    });
    return zones.map(({ rem, ...z }) => z);
};
